import { render, staticRenderFns } from "./WithdrawalRequestCard.vue?vue&type=template&id=66a6a84a"
import script from "./WithdrawalRequestCard.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequestCard.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalRequestCard.vue?vue&type=style&index=0&id=66a6a84a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports